<div class="ml-20px">
  <gh-indicator [(ghValue)]="indicators.loadingIndicator" [ghMessage]="'loading' | localize"></gh-indicator>
</div>
<div class="p-8px" id="personal-notification-layout" *ngIf="!indicators.loadingIndicator">
  <notification-layout [notificationSettings]="notificationSettings" [notificationClass]="'personal'"></notification-layout>
</div>
<div class="ml-20px">
  <gh-indicator [(ghValue)]="indicators.patchIndicator" [ghMessage]="'loading' | localize"></gh-indicator>
</div>
